import { CONTACT_MUTATION } from './mutations';

export { CONTACT_MUTATION };
